import { ReactNode } from "react";
import { useAnalytics } from "@/hooks/useAnalytics";

interface AnalyticsProviderProps {
  children: ReactNode;
}

function AnalyticsTracker() {
  useAnalytics();
  return null;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  return (
    <>
      <AnalyticsTracker />
      {children}
    </>
  );
}
